import React, { Fragment } from 'react'
import TopBanner from '../../Components/Main/TopBanner'
import ShopList from '../../Components/Shop/ShopList'

const Shop = () => {
    return (
        <Fragment>
            <TopBanner title={"shop"} />
            <ShopList />
        </Fragment>
    )
}

export default Shop